{
  "CHAT_LIST": {
    "LOADING": "Sæki samtöl",
    "LOAD_MORE_CONVERSATIONS": "Sækja fleiri spjöll",
    "EOF": "Öll spjöll eru hlaðin🎉",
    "LIST": {
      "404": "Það eru engin virk spjöll í þessum hóp."
    },
    "FAILED_TO_SEND": "Failed to send",
    "TAB_HEADING": "Samtöl",
    "MENTION_HEADING": "Mentions",
    "UNATTENDED_HEADING": "Unattended",
    "SEARCH": {
      "INPUT": "Leita að Fólki, Spjöllum, Vistuðum Svörum .."
    },
    "SEARCH_MESSAGES": "Leita í samtölum",
    "SEARCH_INPUT_PLACEHOLDER": "Leita í samtölum...",
    "FILTER_ALL": "Allt",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Mitt",
      "unassigned": "Óúthlutað",
      "all": "Allt"
    },
    "MESSAGE_USE_AS_TEMPLATE": "Líma í svar",
    "CARDS": {
      "ACTIONS": {
        "OPEN": "Opna",
        "BUY": "Kaupa"
      }
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Opin"
      },
      "resolved": {
        "TEXT": "Leyst"
      },
      "pending": {
        "TEXT": "Í bið"
      },
      "snoozed": {
        "TEXT": "Blundað"
      },
      "all": {
        "TEXT": "Allt"
      }
    },
    "VIEW_FILTER": "Skoða",
    "SORT_TOOLTIP_LABEL": "Sort conversations",
    "CHAT_SORT": {
      "STATUS": "Staða",
      "ORDER_BY": "Order by"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": "Skráð",
      "LAST_ACTIVITY": "Last activity:",
      "LAST_CUSTOMER_MESSAGE": "Síðustu skilaboð viðskiptavinar:"
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Last activity: Oldest first"
      },
      "last_activity_at_desc": {
        "TEXT": "Last activity: Newest first"
      },
      "last_customer_message_at_asc": {
        "TEXT": "Síðustu skilaboð viðskiptavinar: Elst fyrst"
      },
      "last_customer_message_at_desc": {
        "TEXT": "Síðustu skilaboð viðskiptavinar: Nýjast fyrst"
      },
      "created_at_desc": {
        "TEXT": "Created at: Newest first"
      },
      "created_at_asc": {
        "TEXT": "Created at: Oldest first"
      },
      "priority_desc": {
        "TEXT": "Priority: Highest first"
      },
      "priority_asc": {
        "TEXT": "Priority: Lowest first"
      },
      "priority_created_at_desc": {
        "TEXT": "Forgangur + Stofnað: Nýjast fyrst"
      },
      "priority_created_at_asc": {
        "TEXT": "Forgangur + Stofnað: Elst fyrst"
      },
      "waiting_since_asc": {
        "TEXT": "Pending Response: Longest first"
      },
      "waiting_since_desc": {
        "TEXT": "Pending Response: Shortest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Myndaskilaboð"
      },
      "audio": {
        "CONTENT": "Hljóðskilaboð"
      },
      "video": {
        "CONTENT": "Myndbandsskilaboð"
      },
      "file": {
        "CONTENT": "File Attachment"
      },
      "location": {
        "CONTENT": "Staðsetning"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "hefur deilt vefslóð"
      },
      "contact": {
        "CONTENT": "Shared contact"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Sort conversation",
      "DROPDOWN_TITLE": "Sort by",
      "ITEMS": {
        "LATEST": {
          "NAME": "Last activity at",
          "LABEL": "Last activity"
        },
        "CREATED_AT": {
          "NAME": "Created at",
          "LABEL": "Created at"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Last user message at",
          "LABEL": "Last message"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Móttekið í tölvupósti",
    "VIEW_TWEET_IN_TWITTER": "Opna tíst á Twitter",
    "REPLY_TO_TWEET": "Svara þessu tísti",
    "LINK_TO_STORY": "Opna instagram sögu",
    "SENT": "Sent",
    "READ": "Lesið",
    "DELIVERED": "Afhent",
    "NO_MESSAGES": "Engin skilaboð",
    "NO_CONTENT": "Ekkert efni fannst",
    "HIDE_QUOTED_TEXT": "Fela tilvitnaðan texta",
    "SHOW_QUOTED_TEXT": "Sýna tilvitnaðan texta",
    "HIDE_AUTOMATED_MESSAGE": "Fela efni sjálfvirks svars",
    "SHOW_AUTOMATED_MESSAGE": "Sýna efni sjálfvirks svars",
    "AUTOMATED_MESSAGE": "Sjálfvirkt svar",
    "MESSAGE_READ": "Lesið",
    "SENDING": "Sending"
  }
}
